import { useTranslation } from "react-i18next";
import CreateStepType from "../../components/forms/CreateStepType";

function Steps() {
  const { t } = useTranslation();
  return (
    <>
      <div>{t("pages.calls.step-api")}</div>
      <CreateStepType />
    </>
  );
}

export default Steps;
